/**
 * @fileoverview CSS module for the Redirect component.
 * Provides styling for the Redirect component, which displays a redirect message and a spinner.
 *
 * @example
 * // Usage in a component:
 * import styles from './Redirect.module.css'
 *
 * function Redirect() {
 *   return <div className={styles.container}>Redirecting...</div>
 * }
 */

@keyframes spinner {
    0% {
        transform: rotate(0turn);
    }

    100% {
        transform: rotate(1turn);
    }
}

.spinner {
    position: absolute;
    animation-name: spinner;
    animation-duration: 500ms;
    animation-timing-function: ease-out;
    animation-iteration-count: infinite;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.content {
    width: 4rem;
    height: 4rem;
    background-color: var(--neutural000);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 8px 20px -4px #312e811f;
}

.header {
    margin-top: 1rem;
    font-size: 1.5rem;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin-bottom: 0;
}

.description {
    margin: 1rem 0 2rem;
}
